import { createContext, ReactNode, useContext } from "react";

type Context = {
  readOnly: boolean;
};

const NoteCodesContext = createContext<Context>({
  readOnly: false,
});

export const NoteCodesContextProvider = ({
  readOnly,
  ...rest
}: Context & { children?: ReactNode }) => (
  <NoteCodesContext.Provider
    value={{
      readOnly,
    }}
    {...rest}
  />
);

export const useNoteCodes = () => useContext(NoteCodesContext);
